import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isEmpty } from 'lodash';

@Pipe({ name: 'class', })
export class ClassPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) { }

  public transform(value: any): string | string[] {
    if (isEmpty(value)) {
      return '';
    }

    return value;
  }
}
